import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center gap-4 p-12 text-center">
      <div className="text-5xl font-bold text-ink-3 num">404</div>
      <div className="text-sm text-ink-2">页面不存在或权限不足</div>
      <Button asChild>
        <Link to="/dashboard">返回仪表板</Link>
      </Button>
    </div>
  );
}
